import React from 'react';
import { useIntl } from 'react-intl';
import { Divider } from 'antd';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';

dayjs.extend(isToday);
dayjs.extend(isYesterday);

interface ChatDayDividerProps {
  date: string | Date;
  className?: string;
}

export const ChatDayDivider: React.FC<ChatDayDividerProps> = ({
  date,
  className,
}) => {
  const intl = useIntl();
  const dateObj = dayjs(date);

  let displayText: string;
  if (dateObj.isToday()) {
    displayText = intl.formatMessage({ id: 'chat.today' });
  } else if (dateObj.isYesterday()) {
    displayText = intl.formatMessage({ id: 'chat.yesterday' });
  } else {
    displayText = dateObj.format('DD.MM.YYYY');
  }

  return (
    <Divider plain className={className}>
      {displayText}
    </Divider>
  );
};

export default ChatDayDivider;
